import * as React from 'react'
import Helmet from 'react-helmet'

import { Product } from '../catalog/ProductPage/GetProduct.query'
import { ProductStockStatus } from '../graphql/schema.generated'
import { getPrices } from '../presentation/PriceBox'
import makeMediaUrl, { MediaType } from '../utils/makeMediaUrl'

const ProductRichSnippet = (product: Product) => {
    const {
        mediaGalleryEntries,
        name,
        description,
        sku,
        brand,
        hexColor,
        materialOutside,
        stockStatus,
    } = product

    if (!mediaGalleryEntries) {
        return null
    }
    const images = mediaGalleryEntries
        .filter((image) => image.file && !image.disabled)
        .sort((a, b) => a.position - b.position)
        .map(({ file }) => makeMediaUrl(file, MediaType.Product))

    const url = `${window.location.origin}${window.location.pathname}`
    const prices = getPrices(product)

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org/',
                    '@type': 'Product',
                    name,
                    image: images,
                    description: description?.html,
                    sku,
                    brand: {
                        '@type': 'Brand',
                        name: brand,
                    },
                    color: hexColor,
                    material: materialOutside,
                    offers: {
                        '@type': 'Offer',
                        url,
                        priceCurrency:
                            prices && prices.actualPrice
                                ? prices.actualPrice.currency
                                : undefined,
                        price:
                            prices && prices.actualPrice
                                ? prices.actualPrice.value
                                : undefined,
                        availability:
                            stockStatus === ProductStockStatus.IN_STOCK
                                ? 'https://schema.org/InStock'
                                : 'https://schema.org/OutOfStock',
                    },
                })}
            </script>
        </Helmet>
    )
}

export default ProductRichSnippet
